// src/BlogPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CssBaseline, Container, Box, Typography, Button, Card, CardContent, CardActions, Grid } from '@mui/joy';
import {BACKEND_API_URL} from '../data/constant'

function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await fetch(BACKEND_API_URL+ 'posts', {credentials: 'include'});
        if (!response.ok) {

          throw new Error('Failed to fetch blog posts' + response.statusText);
        }
        const data = await response.json();
        setBlogPosts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  if (loading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <Typography level="h4">Loading blog posts...</Typography>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <Typography level="h4" color="danger">Error: {error}</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <CssBaseline />
      <Container maxWidth="md">
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <Typography level="h1" fontWeight="bold" component="h1" gutterBottom>
            My Tech Blog
          </Typography>
          <Typography level="h3" component="h2" gutterBottom>
            Latest Articles
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {blogPosts.map((post) => (
            <Grid item xs={12} sm={6} key={post.id}>
              <Card variant="outlined">
                <CardContent>
                  <Typography level="h2" fontWeight="bold" gutterBottom>
                    {post.title}
                  </Typography>
                  <Typography level="body1" gutterBottom>
                    {post.excerpt}
                  </Typography>
                  <Typography level="body3" color="neutral">
                    By {post.author} on {post.date}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button component={Link} to={`/post/${post.id}`} variant="soft" color="primary">
                    Read More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}

export default BlogPage;